import Heading, { HeadingSize } from '@/components/atoms/Heading';
import { RadioCards } from '@/components/atoms/RadioCards';
import { useTheme } from 'styled-components';
import { ProdutoCombo } from '@/types/combo';
import * as S from './styles';
import Imagem from '@/components/atoms/Imagem';
import RadioCardItem from '@/components/molecules/RadioCardItem';
import { CSSProperties, Dispatch, SetStateAction } from 'react';

interface ProvidersPlanoProps {
  $tituloProvidersInclusos: string;
  $tituloProvidersInclusosTamanho: HeadingSize;
  $tituloEscolhaProvidersVariaveis: string;
  $tituloEscolhaProvidersVariaveisTamanho: HeadingSize;
  $alturaImagemProvidersInclusos?: number;
  $larguraImagemProvidersInclusos?: number;
  $alturaImagemProvidersVariaveis?: number;
  $larguraImagemProvidersVariaveis?: number;
  $produtos: Array<ProdutoCombo>;
  $produtoSelecionadoID: string | null | undefined;
  $selecionarProdutoSelecionado: Dispatch<
    SetStateAction<string | null | undefined>
  >;
  style?: CSSProperties;
}

export default function ProvidersPlano(props: ProvidersPlanoProps) {
  const {
    $tituloProvidersInclusos,
    $tituloProvidersInclusosTamanho,
    $tituloEscolhaProvidersVariaveis,
    $tituloEscolhaProvidersVariaveisTamanho,
    $alturaImagemProvidersInclusos = 49,
    $larguraImagemProvidersInclusos = 73,
    $alturaImagemProvidersVariaveis = 40,
    $larguraImagemProvidersVariaveis = 40,
    $produtos,
    $produtoSelecionadoID,
    $selecionarProdutoSelecionado,
    style,
  } = props;
  const theme = useTheme();
  return (
    <S.ContainerProviders style={style}>
      <S.ContainerDetalhesProviders>
        <Heading
          $priority={3}
          $size={$tituloProvidersInclusosTamanho}
          $color="neutral"
          $weight="bold"
          $align="left"
          $highContrast={true}
          $text={$tituloProvidersInclusos}
        />
        <RadioCards
          $size={1}
          $displayGrid
          $colunasGrid={4}
          $orientation="horizontal"
          $totalRadioCards={4}
          $espacamentoColunaGrid={theme.spacing[2]}
        >
          {$produtos
            .filter((produto) => !produto.variavel)
            .map((produto) => (
              <S.ContainerImagemProdutoIncluso
                $larguraImagem={$larguraImagemProvidersInclusos}
                $alturaImagem={$alturaImagemProvidersInclusos}
                key={produto.id}
              >
                <Imagem
                  descricaoImagem={produto.id}
                  priority={true}
                  imagemUrl={produto.imagem}
                  style={{
                    borderRadius: theme.radius[2],
                  }}
                  propsNextImage={{
                    unoptimized: true,
                  }}
                />
              </S.ContainerImagemProdutoIncluso>
            ))}
        </RadioCards>
      </S.ContainerDetalhesProviders>
      <S.ContainerEscolhaProviders>
        <Heading
          $priority={2}
          $size={$tituloEscolhaProvidersVariaveisTamanho}
          $color="neutral"
          $weight="bold"
          $align="left"
          $highContrast={true}
          $text={$tituloEscolhaProvidersVariaveis}
        />
        <RadioCards
          $size={1}
          $orientation="horizontal"
          $displayGrid
          $colunasGrid={4}
          $totalRadioCards={4}
          $espacamentoColunaGrid={theme.spacing[2]}
        >
          {$produtos.length > 0
            ? $produtos
                .filter((produto) => produto.variavel)
                .map((produto) => (
                  <S.BotaoEscolherProvider
                    onClick={() => $selecionarProdutoSelecionado(produto.id)}
                    key={produto.id}
                  >
                    <RadioCardItem
                      $size={1}
                      $variant="surface"
                      $highContrast={false}
                      $state={
                        $produtoSelecionadoID === produto.id
                          ? 'checked'
                          : 'default'
                      }
                    >
                      <S.ContainerImagemProdutoVariavel
                        $alturaImagem={$alturaImagemProvidersVariaveis}
                        $larguraImagem={$larguraImagemProvidersVariaveis}
                      >
                        <Imagem
                          descricaoImagem={produto.id}
                          priority={true}
                          imagemUrl={produto.imagem}
                          style={{
                            borderRadius: theme.radius[2],
                          }}
                          propsNextImage={{
                            unoptimized: true,
                          }}
                        />
                      </S.ContainerImagemProdutoVariavel>
                    </RadioCardItem>
                  </S.BotaoEscolherProvider>
                ))
            : null}
        </RadioCards>
      </S.ContainerEscolhaProviders>
    </S.ContainerProviders>
  );
}
